import React from 'react';

import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';

import CloseIcon from '@mui/icons-material/Close';

import { useDebriefApp, useDebriefSelector } from 'ff/debrief/hooks';

const ToastBar = () => {
    const { isToastOpen, closeToast } = useDebriefApp();
    const toastMessage = useDebriefSelector(s => s.appSlice.toast.message);

    return (
        <Snackbar
            open={isToastOpen}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            autoHideDuration={6000}
            onClose={closeToast}
            message={toastMessage}
            action={
                <IconButton
                    size="small"
                    aria-label="close"
                    color="inherit"
                    onClick={closeToast}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            }
        ></Snackbar>
    );
};

export default ToastBar;
